import { SoeknadstypeWeb } from '../../generated-types';
import {
    PAGE_BARN_URL,
    PAGE_BILER_URL,
    PAGE_BOLIGSALG_URL,
    PAGE_BOLIGVERDI_URL,
    PAGE_EGENKAPITAL_URL,
    PAGE_GJELD_URL,
    PAGE_INNTEKT_URL,
    PAGE_KONTAKTINFORMASJON_URL,
    PAGE_LAANEBELOP_URL,
    PAGE_LEIEINNTEKT_URL,
    PAGE_OPPSUMMERING_URL,
    PAGE_ROOT,
    PAGE_SAMTYKKE_URL,
    PAGE_VEDLEGG_URL,
} from './pageUrl';

export const PageOrder = (
    soeknadsType: SoeknadstypeWeb,
    featureToggleUtvideDatagrunnlag: boolean = false,
): string[] => {
    switch (soeknadsType) {
        case SoeknadstypeWeb.REFINANSIERE_BOLIGLAAN:
            return [
                PAGE_ROOT,
                PAGE_BOLIGVERDI_URL,
                PAGE_LAANEBELOP_URL,
                PAGE_KONTAKTINFORMASJON_URL,
                PAGE_SAMTYKKE_URL,
                PAGE_INNTEKT_URL,
                PAGE_LEIEINNTEKT_URL,
                PAGE_BILER_URL,
                PAGE_BARN_URL,
                PAGE_GJELD_URL,
                PAGE_VEDLEGG_URL,
                PAGE_OPPSUMMERING_URL,
            ];
        case SoeknadstypeWeb.FLYTTE_BOLIGLAAN:
            return [
                PAGE_ROOT,
                PAGE_BOLIGVERDI_URL,
                PAGE_LAANEBELOP_URL,
                PAGE_KONTAKTINFORMASJON_URL,
                PAGE_SAMTYKKE_URL,
                PAGE_INNTEKT_URL,
                PAGE_LEIEINNTEKT_URL,
                PAGE_BILER_URL,
                PAGE_BARN_URL,
                PAGE_GJELD_URL,
                PAGE_VEDLEGG_URL,
                PAGE_OPPSUMMERING_URL,
            ];
        case SoeknadstypeWeb.KJOEPE_BOLIG:
            return [
                PAGE_ROOT,
                PAGE_BOLIGSALG_URL,
                PAGE_KONTAKTINFORMASJON_URL,
                PAGE_SAMTYKKE_URL,
                PAGE_INNTEKT_URL,
                PAGE_LEIEINNTEKT_URL,
                PAGE_BILER_URL,
                PAGE_BARN_URL,
                PAGE_EGENKAPITAL_URL,
                PAGE_GJELD_URL,
                PAGE_VEDLEGG_URL,
                PAGE_OPPSUMMERING_URL,
            ];
        case SoeknadstypeWeb.FINANSIERINGSBEVIS:
            return [
                PAGE_ROOT,
                PAGE_BOLIGSALG_URL,
                PAGE_KONTAKTINFORMASJON_URL,
                PAGE_SAMTYKKE_URL,
                PAGE_INNTEKT_URL,
                PAGE_LEIEINNTEKT_URL,
                PAGE_BILER_URL,
                PAGE_BARN_URL,
                PAGE_EGENKAPITAL_URL,
                PAGE_GJELD_URL,
                PAGE_VEDLEGG_URL,
                PAGE_OPPSUMMERING_URL,
            ];
        case SoeknadstypeWeb.NYTT_BOLIGLAAN:
            return [
                PAGE_ROOT,
                PAGE_BOLIGVERDI_URL,
                PAGE_KONTAKTINFORMASJON_URL,
                PAGE_SAMTYKKE_URL,
                PAGE_INNTEKT_URL,
                PAGE_LEIEINNTEKT_URL,
                PAGE_BILER_URL,
                PAGE_BARN_URL,
                PAGE_GJELD_URL,
                PAGE_VEDLEGG_URL,
                PAGE_OPPSUMMERING_URL,
            ];
        case SoeknadstypeWeb.MEDLAANTAKER:
            return featureToggleUtvideDatagrunnlag
                ? [
                      PAGE_ROOT,
                      PAGE_SAMTYKKE_URL,
                      PAGE_INNTEKT_URL,
                      PAGE_BILER_URL,
                      PAGE_BARN_URL,
                      PAGE_GJELD_URL,
                      PAGE_VEDLEGG_URL,
                      PAGE_OPPSUMMERING_URL,
                  ]
                : [
                      PAGE_ROOT,
                      PAGE_SAMTYKKE_URL,
                      PAGE_INNTEKT_URL,
                      PAGE_BARN_URL,
                      PAGE_GJELD_URL,
                      PAGE_VEDLEGG_URL,
                      PAGE_OPPSUMMERING_URL,
                  ];
        case SoeknadstypeWeb.MEDLAANTAKER_EGENKAPITAL:
            return featureToggleUtvideDatagrunnlag
                ? [
                      PAGE_ROOT,
                      PAGE_SAMTYKKE_URL,
                      PAGE_INNTEKT_URL,
                      PAGE_BILER_URL,
                      PAGE_BARN_URL,
                      PAGE_EGENKAPITAL_URL,
                      PAGE_GJELD_URL,
                      PAGE_VEDLEGG_URL,
                      PAGE_OPPSUMMERING_URL,
                  ]
                : [
                      PAGE_ROOT,
                      PAGE_SAMTYKKE_URL,
                      PAGE_INNTEKT_URL,
                      PAGE_BARN_URL,
                      PAGE_EGENKAPITAL_URL,
                      PAGE_GJELD_URL,
                      PAGE_VEDLEGG_URL,
                      PAGE_OPPSUMMERING_URL,
                  ];

        default:
            return [];
    }
};
